export default __webpack_public_path__ + "images/logo_white-4dcc8d5b3a3a2cf7249db603c37b815d.svg";